import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { EventEntity } from './event.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

@Index('event_client__fk__event__id_fk', ['fkEventId'], {})
@Index(
	'event_client__fk_m_sm_client_opportunity__id_fk',
	['fkMSmClientOpportunityId'],
	{},
)
@Index('event_client_pk', ['fkEventId', 'fkClientId'], { unique: true })
@Entity('event_client')
export class EventClientEntity extends BaseEntity {
	@Column('int', { name: '_fk__event__id', unsigned: true })
	public fkEventId!: number;

	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', {
		name: '_fk_m_sm_client_opportunity__id',
		nullable: true,
		unsigned: true,
	})
	public fkMSmClientOpportunityId!: number | null;

	@ManyToOne(() => ClientEntity, (client) => client.eventClients, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => EventEntity, (event) => event.eventClients, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__event__id', referencedColumnName: 'id' }])
	public fkEvent!: EventEntity;

	@ManyToOne(
		() => MSmClientOpportunityEntity,
		(opportunity) => opportunity.eventClients,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([
		{ name: '_fk_m_sm_client_opportunity__id', referencedColumnName: 'id' },
	])
	public fkMSmClientOpportunity!: MSmClientOpportunityEntity | null;
}
